import type { SVGProps } from "react";
import * as React from "react";

const SvgChevronsLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.293 17.707a1 1 0 0 0 1.414-1.414zM6 12l-.707-.707a1 1 0 0 0 0 1.414zm5.707-4.293a1 1 0 0 0-1.414-1.414zm5.586 10a1 1 0 0 0 1.414-1.414zM13 12l-.707-.707a1 1 0 0 0 0 1.414zm5.707-4.293a1 1 0 0 0-1.414-1.414zm-7 8.586-5-5-1.414 1.414 5 5zm-5-3.586 5-5-1.414-1.414-5 5zm12 3.586-5-5-1.414 1.414 5 5zm-5-3.586 5-5-1.414-1.414-5 5z"
    />
  </svg>
);
export default SvgChevronsLeft;
